import { createAction } from '@reduxjs/toolkit';

const getEquipmentData = createAction('equipment/getEquipmentData');
// const equipmentRequest = createAction('equipment/equipmentRequest');
const equipmentError = createAction('equipment/equipmentError');
const getEquipmentDataAdd = createAction('equipment/getEquipmentDataAdd');
const deleteEquipment = createAction('equipment/deleteEquipment');
const createNewEquipment = createAction('equipment/createNewEquipment');
const updateEquipment = createAction('equipment/updateEquipment');
const resetHasMore = createAction('equipment/resetHasMore');

export default {
  getEquipmentData,
  // equipmentsRequest,
  equipmentError,
  getEquipmentDataAdd,
  deleteEquipment,
  createNewEquipment,
  updateEquipment,
  resetHasMore,
};
